
###
S360 global level search with drawer panel
###

# Libs
import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
# Renderable
import { h2 } from 'react-dom-factories'

import _Drawer from '@atlaskit/drawer'
Drawer = React.createFactory _Drawer

# Styles
import styles from './index.styl'


export default class SearchDrawer extends React.Component
	@propTypes:
		close: PropTypes.func
		isOpen: PropTypes.bool
		headerComponent: PropTypes.func
	@defaultProps:
		headerComponent: h2
	render: ->
		Drawer
			onClose: @props.close
			isOpen: @props.isOpen
			width: 'wide'
		,
			@props.headerComponent {className: styles.header}, 'Search'
